<input
  #fileInput
  type="file"
  [accept]="accept"
  [multiple]="multiple"
  [disabled]="disabled"
  (change)="onFileInputChange($event)"
  class="hidden-input" />

<!-- Box Type: Drag and drop area with dotted border -->
<div
  *ngIf="type === 'box'"
  class="file-upload-box"
  [class.drag-over]="isDragOver"
  [class.disabled]="disabled"
  [class.has-file]="selectedFiles.length > 0"
  [class.uploading]="isUploading"
  [style.background-color]="!isUploading ? boxBackgroundColor : null"
  [style.border-color]="!isUploading ? boxBorderColor : null">

  <div class="uploading-state" *ngIf="isUploading">
    <p class="uploading-text" [style.color]="uploadingTextColor">{{ uploadingText }}</p>
    <lib-cdw-spinner type="apple" size="large"></lib-cdw-spinner>
  </div>

  <div class="upload-content" *ngIf="!isUploading">
    <div *ngIf="showIcon" class="icon-container">
      <mat-icon>{{ iconName }}</mat-icon>
    </div>

    <p
      class="drag-message"
      [style.font-family]="dragMessageFontFamily"
      [style.font-size]="dragMessageFontSize"
      [style.font-weight]="dragMessageFontWeight"
      [style.color]="dragMessageColor">
      {{ dragMessage }}
    </p>

    <div
      *ngIf="displayText"
      class="selected-file-text"
      [style.font-family]="selectedFileTextFontFamily"
      [style.font-size]="selectedFileTextFontSize"
      [style.font-weight]="selectedFileTextFontWeight">
      {{ displayText }}
    </div>

    <lib-cdw-button
      mode="standard"
      [level]="buttonLevel"
      [disabled]="disabled"
      (buttonClick)="fileInput.click()">
      <span
        [style.font-family]="buttonLabelFontFamily"
        [style.font-size]="buttonLabelFontSize"
        [style.font-weight]="buttonLabelFontWeight"
        [style.color]="buttonLabelColor">
        {{ buttonText }}
      </span>
    </lib-cdw-button>
  </div>
</div>

<!-- Button Type: Simple file select button -->
<div *ngIf="type === 'button'" class="file-upload-button">
  <lib-cdw-button
    mode="standard"
    [level]="buttonLevel"
    [disabled]="disabled"
    (buttonClick)="fileInput.click()">
    <span
      [style.font-family]="buttonLabelFontFamily"
      [style.font-size]="buttonLabelFontSize"
      [style.font-weight]="buttonLabelFontWeight"
      [style.color]="buttonLabelColor">
      {{ buttonText }}
    </span>
  </lib-cdw-button>

  <span
    *ngIf="displayText"
    class="selected-file-text"
    [style.font-family]="selectedFileTextFontFamily"
    [style.font-size]="selectedFileTextFontSize"
    [style.font-weight]="selectedFileTextFontWeight">
    {{ displayText }}
  </span>
  <span *ngIf="!displayText && !disabled" class="no-file-text">
    No file chosen
  </span>
</div>
